/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router'
import slugs from '../slugs.js'

export const paths = Object.keys(slugs).map(locale => {
  const websiteSlug = slugs[locale]
  return {
    path: `/docs/${locale}/${websiteSlug}/:slug/`,
    props: {
      locale,
    },
  }
})

const DocsSlugDocumentRedirect = ({ locale }) => {
  let { slug } = useParams()
  let location = useLocation()
  let querystring = location.search
  return <Navigate exact to={`/docs/${locale}/${slug}${querystring}`} />
}

export default DocsSlugDocumentRedirect
